module.exports = __webpack_public_path__ + "media/app/img/gmaker-logo128-ebb7b6ff61a07be251a852d23e77f094.png";